// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__blTmQ","slide-in-right":"Button_slide-in-right__3DZM0","slide-out-right":"Button_slide-out-right__3u_F0"};